import React, { useContext, useEffect, useState } from "react";
import SearchBox from "../../page-essentials/SearchBar";
import SocialMedia from "../../page-essentials/SocialMedia";
import ImageGallery from "react-image-gallery";
import Carousel from "../../page-essentials/Carousel";
import LangContext from "../../../context/LangContext";

const HeroSection = () => {
  const images: string[] = [
    "https://images.unsplash.com/photo-1611516491426-03025e6043c8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1633&q=80",
    "https://images.unsplash.com/photo-1533130061792-64b345e4a833?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    "https://images.unsplash.com/photo-1584395631446-e41b0fc3f68d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
  ];

  const headings = {
    en: [
      "Unveiling the Mystique of Nepal: A Journey to Remember!",
      "Embark on an Adventure in Nepal: Where Nature and Culture Converge.",
      "Discover Nepal's Hidden Wonders: Trek, Explore, and Embrace the Magic!",
      "Nepal: Your Gateway to Thrilling Expeditions and Unforgettable Memories.",
      "Trekking in Nepal: Embrace the Challenge, Embrace the Beauty.",
      "Nepal's Natural Splendor Awaits: Begin Your Adventure Today!",
    ],
    fr: [
      "Népal : Dévoilement de la Mystique - Un Voyage Inoubliable !",
      "Aventurez-vous au Népal : Quand Nature et Culture se Conjuguent.",
      "Découvrez les Merveilles Cachées du Népal : Randonnée, Exploration, Magie !",
      "Népal : Où les Montagnes Touffent le Ciel et la Spiritualité Touche l'Âme.",
      "Explorez l'Héritage Riche du Népal et ses Paysages à Couper le Souffle.",
      "Népal : Votre Porte d'Entrée vers des Expéditions Époustouflantes et des Souvenirs Inoubliables.",
      "Immergez-vous dans la Beauté et la Chaleur du Népal : Votre Destination de Voyage Ultime.",
      "Randonnée au Népal : Affrontez le Défi, Émerveillez-vous devant la Beauté.",
      "Splendeur Naturelle du Népal en Attente : Commencez Votre Aventure Aujourd'hui !",
      "Voyage au Népal : Où Chaque Pas Dévoile une Histoire d'Aventure et de Sérénité.",
    ],
  };
  const { lang_code } = useContext(LangContext);

  const findRandomHeading = (): string => {
    const randomIndex = Math.floor(Math.random() * headings[lang_code].length);
    console.log(headings[lang_code]);
    return headings[lang_code][randomIndex];
  };
  const [heading, setHeading] = useState("");
  useEffect(() => {
    if (lang_code) {
      setHeading(findRandomHeading());
    }
  }, [lang_code]);
  return (
    <div className="h-screen w-full overflow-hidden ">
      <div className="h-full w-full ">
        <Carousel
          images={images}
          interval={5000}
          className="w-full h-full z-0 absolute object-cover"
        />
        {/* <img
          src={slideImg}
          alt=""
          srcSet=""
          className="w-full h-full z-0 absolute object-cover"
        /> */}
        {/* overlay  */}
        <div className="h-full w-full z-0 absolute overlay-gradient"></div>
        <div className="flex flex-col items-center justify-center relative h-full">
          <SocialMedia color="text-white" className="text-2xl" />

          <h1 className="text-white text-4xl sm:text-4xl md:text-5xl xl:text-[3rem] font-bold capitalize w-11/12 sm:w-3/4 md:w-2/3 lg:w-[55%] text-center leading-[3.5rem] sm:leading-[3rem] xl:leading-[4rem] drop-shadow-lg animate-to-right">
            {heading}
          </h1>
          <SearchBox />
          {/* <div className="mt-4 text-white drop-shadow-md font-medium">
            <p style={{ textShadow: "1px 1px 1.5px #616161" }}>
              +977-9867842300 || ultimatetrekking@gmail.com
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
